export const DOCUMENT_ERROR_I18N_KEYS = {
  no_account_hosts: 'CAPTAIN.DOCUMENTS.SYNC_ERRORS.NO_ACCOUNT_HOSTS',
  host_not_allowed: 'CAPTAIN.DOCUMENTS.SYNC_ERRORS.HOST_NOT_ALLOWED',
  robots_disallowed: 'CAPTAIN.DOCUMENTS.SYNC_ERRORS.ROBOTS_DISALLOWED',
  not_found: 'CAPTAIN.DOCUMENTS.SYNC_ERRORS.NOT_FOUND',
  access_denied: 'CAPTAIN.DOCUMENTS.SYNC_ERRORS.ACCESS_DENIED',
  timeout: 'CAPTAIN.DOCUMENTS.SYNC_ERRORS.TIMEOUT',
  content_empty: 'CAPTAIN.DOCUMENTS.SYNC_ERRORS.CONTENT_EMPTY',
  fetch_failed: 'CAPTAIN.DOCUMENTS.SYNC_ERRORS.FETCH_FAILED',
  sync_error: 'CAPTAIN.DOCUMENTS.SYNC_ERRORS.SYNC_ERROR',
  quota_exceeded: 'CAPTAIN.DOCUMENTS.SYNC_ERRORS.QUOTA_EXCEEDED',
  captain_disabled: 'CAPTAIN.DOCUMENTS.SYNC_ERRORS.DISABLED',
};

export const DOCUMENT_CREATE_ERROR_I18N_KEYS = {
  ...DOCUMENT_ERROR_I18N_KEYS,
  no_account_hosts: 'CAPTAIN.DOCUMENTS.FORM.URL.NO_HOSTS',
  host_not_allowed: 'CAPTAIN.DOCUMENTS.FORM.URL.HOST_NOT_ALLOWED',
};

export const documentErrorMessage = (error, t, fallbackKey, keys = DOCUMENT_ERROR_I18N_KEYS) => {
  const code = error?.errorCode || error?.response?.data?.error_code;
  const key = keys[code];
  if (key) return t(key);
  return t(fallbackKey);
};
